// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadableWrapper_container__28Mbi"};